import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import color from "@constants/color";
import { useFocusEffect } from "@react-navigation/native";
import { getReconHistory } from "@services/api";
import React, { useCallback, useState } from "react";
import { FlatList, View, StyleSheet, ActivityIndicator } from "react-native";
import Text from "@components/CustomText";
import ReconListTile from "./components/ReconListTile";

const ReconHistory = ({ navigation, route }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  useFocusEffect(
    useCallback(() => {
      fetchData();
    }, []),
  );

  const fetchData = async () => {
    try {
      setLoading(true);

      // eslint-disable-next-line no-shadow
      const { data } = await getReconHistory();

      setData(data?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const renderItem = ({ item }) => {
    return <ReconListTile item={item} isHistory={true} />;
  };

  const renderEmptyComponent = () => {
    return (
      <View
        style={{
          marginTop: "70%",
          alignSelf: "center",
        }}
      >
        <Text variant="subtitle_20" style={{ color: color.black06 }}>
          No Recon History !
        </Text>
      </View>
    );
  };

  return (
    <View style={{ flex: 1 }}>
      <HeaderWithBackAndTitle
        headertitle="History"
        headerColor="#fff"
        hideShadow={true}
        navigation={navigation}
        route={route}
        rightComponent={
          <View style={styles.rightComponent}>
            <Text variant="caption_2" style={{ color: color.black06 }}>
              Last 10 days
            </Text>
          </View>
        }
      />
      {loading ? (
        <ActivityIndicator
          size="large"
          color={color.primary}
          style={styles.loading}
        />
      ) : (
        <FlatList
          data={data || []}
          keyExtractor={(item) => item.db_id}
          renderItem={renderItem}
          style={{ marginTop: 8 }}
          ListEmptyComponent={renderEmptyComponent}
        />
      )}
    </View>
  );
};

export default ReconHistory;

const styles = StyleSheet.create({
  loading: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  rightComponent: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: 8,
  },
});
